const ITEMS = [
  "Okavango Delta",
  "Victoria Falls",
  "Sossusvlei Dunes",
  "Cape Winelands",
  "Chobe River",
  "Skeleton Coast",
  "Tour Operators",
  "Luxury Lodges",
  "Travel Agencies",
  "DMC Partners",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-goldline bg-coal/60 py-6">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-gold/50">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-gold/30" />
          </span>
        ))}
      </div>
    </div>
  );
}
